import { queryOptions, useQuery } from '@tanstack/react-query';

import { STALE_TIMES } from '../reactQueryClientConfig';
import { fetchMaterializedMenuProduct } from './materializedMenuProduct.api';
import type { MaterializedMenuProduct } from './materializedMenuProduct.types';
import type { GetArgs } from './materializedMenuProduct.utils';

export const materializedMenuProductQueryOptions = ({
  productId,
  storeId,
}: GetArgs) =>
  queryOptions({
    enabled: !!productId && !!storeId,
    queryFn: () => fetchMaterializedMenuProduct({ productId, storeId }),
    queryKey: ['materializedMenuProduct', storeId, productId],
    staleTime: STALE_TIMES.short,
  });

export const useMaterializedMenuProduct = (
  args: GetArgs,
  { initialData }: { initialData: MaterializedMenuProduct }
) => useQuery({ ...materializedMenuProductQueryOptions(args), initialData });
